export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7900.6248cd14.jpg";